import { useCallback, useState } from 'react';

export const usePasswordTooltip = (initialValue = '') => {
    const [checkPasswordValue, setCheckPasswordValue] = useState(initialValue);
    const [isShowPasswordTooltip, setIsShowPasswordTooltip] = useState(false);

    const onChangePasswordField = useCallback((e) => {
        setCheckPasswordValue(e.currentTarget.value);
    }, []);

    const onSelectPasswordField = useCallback(() => setIsShowPasswordTooltip(true), []);

    const onBlurPasswordField = useCallback(() => setIsShowPasswordTooltip(false), []);

    return {
        checkPasswordValue,
        isShowPasswordTooltip,
        onBlurPasswordField,
        onChangePasswordField,
        onSelectPasswordField,
    };
};